PJQ.collections.schedule = {};

PJQ.models.schedule = {};

PJQ.views.schedule = {};

PJQ.modules.schedule = {
    routes: [
        {
            route: 'schedule/share/:accessKey',
            name: 'scheduleShare',
            callback: function (accessKey) {
                PJQ.app.session.set('accessKey', accessKey);
                let share = new PJQ.models.schedule.ScheduleShare({
                    accessKey: accessKey
                });
                share.fetch({
                    success: function () {
                        let schedule;
                        if (share.get('lookAheadId') > 0) {
                            schedule = new PJQ.models.schedule.LookAhead({
                                projectId: share.get('projectId'),
                                id: share.get('lookAheadId')
                            });
                        } else if (share.get('projectId') > 0) {
                            schedule = new PJQ.models.schedule.Schedule({
                                projectId: share.get('projectId')
                            });
                        }
                        schedule.fetch({
                            success: function () {
                                PJQ.app.view.renderView(PJQ.views.schedule.ScheduleDashboard, {
                                    model: schedule,
                                    shareKey: accessKey
                                });
                            }
                        });
                    }
                });
            }
        },
        {
            route: 'projects/:projectId/schedule',
            name: 'projectSchedule',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectschedule");
            }
        },
        {
            route: 'projects/:projectId/schedule/lookaheads/:lookAheadId',
            name: 'projectSchedule',
            callback: function (projectId, lookAheadId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectschedule", {
                    lookAheadId: parseInt(lookAheadId),
                    noRoute: true
                });
            }
        },
        {
            route: 'projects/:projectId/schedule/:taskId',
            name: 'projectSchedule',
            callback: function (projectId, taskId) {
                PJQ.app.router.navigate('projects/' + projectId.toString() + '/schedule', {
                    trigger: false,
                    replace: true
                });
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectschedule", {
                    taskId: taskId
                });
            }
        },
    ]
};

PJQ.app.addRoutes(PJQ.modules.schedule.routes);